import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'styled-components'
import { applyStyleModifiers } from 'styled-components-modifiers';
import { modifiersType } from 'types'

const LOADING_DOT_MODIFIERS = {
  inverse: ({ theme }) => css`
    svg {
      fill: ${theme.colors.baseInverse};
    }
  `
};

const LoadingDot = ({ className, modifiers }) => (
  <LoadingWrapper className={className} modifiers={modifiers}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <circle cx="10" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle cx="36" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle cx="66" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  </LoadingWrapper>
);

LoadingDot.propTypes = {
  className: PropTypes.string,
  modifiers: modifiersType,
};

LoadingDot.defaultProps = {
  className: '',
  modifiers: []
};

const LoadingWrapper = styled.span`
  svg {
    display: inline-block;
    height: ${props => props.theme.sizes.l};
    width: ${props => props.theme.sizes.l};
  }
  ${applyStyleModifiers(LOADING_DOT_MODIFIERS)}
`;

export default LoadingDot;
